(function () {
  var STORAGE_KEY = 'pendemonium-wishlist';

  function getWishlist() {
    try {
      var value = JSON.parse(localStorage.getItem(STORAGE_KEY));
      return Array.isArray(value) ? value : [];
    } catch (e) {
      return [];
    }
  }

  function saveWishlist(ids) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(ids));
    } catch (e) {
      // localStorage unavailable (private mode etc.) - heart still toggles visually
    }
  }

  function setButtonState(button, isActive) {
    button.classList.toggle('is-active', isActive);
    button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
    button.setAttribute('aria-label', isActive ? 'Remove from wishlist' : 'Add to wishlist');
  }

  function init() {
    var wishlist = getWishlist();
    var buttons = document.querySelectorAll('.card__wishlist[data-wishlist-id]');

    buttons.forEach(function (button) {
      var id = button.getAttribute('data-wishlist-id');
      setButtonState(button, wishlist.indexOf(id) !== -1);

      if (button.getAttribute('data-wishlist-bound')) return;
      button.setAttribute('data-wishlist-bound', 'true');

      button.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();

        var index = wishlist.indexOf(id);
        if (index === -1) {
          wishlist.push(id);
        } else {
          wishlist.splice(index, 1);
        }
        saveWishlist(wishlist);
        setButtonState(button, index === -1);
      });
    });
  }

  function onReady() {
    init();

    // Re-initialize when cards are added dynamically (quick-add modal, pagination, etc.)
    var observer = new MutationObserver(function (mutations) {
      var needsInit = false;
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType !== 1) return;
          if (
            (node.classList && node.classList.contains('card__wishlist')) ||
            (node.querySelectorAll && node.querySelectorAll('.card__wishlist').length)
          ) {
            needsInit = true;
          }
        });
      });
      if (needsInit) init();
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', onReady);
  } else {
    onReady();
  }
})();